import { date, showAlert } from '@/lib/helpers';
import { headers, search } from './attributes';

export default {
  data() {
    return {
      options: {},
      headers,
      search,
      dialog: false,
      isEdit: false,
      editedIndex: -1,
      editedItem: {
        id: null,
        provider_name: '',
        pic_name: '',
        pic_job_position: '',
        pic_phone_number: '',
        pic_email: '',
        url_callback: '',
      },
      defaultItem: {
        id: null,
        provider_name: '',
        pic_name: '',
        pic_job_position: '',
        pic_phone_number: '',
        pic_email: '',
        url_callback: '',
      },
      formLoading: false,
      formErrors: {},
      dialogDelete: false,
      deleteTarget: null,
      deleting: false,
    };
  },

  computed: {
    allData() {
      return this.$store.state.channelProvider.allData;
    },
    totalData() {
      return this.$store.state.channelProvider.totalData;
    },
    totalPage() {
      return this.$store.state.channelProvider.totalPage;
    },
    loading() {
      return this.$store.state.channelProvider.loading;
    },
    dialogTitle() {
      return this.isEdit ? 'Edit Channel Provider' : 'Tambah Channel Provider';
    },
  },

  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },

  methods: {
    getData() {
      const { page = 1, itemsPerPage = 10 } = this.options;

      this.$store
        .dispatch('channelProvider/getData', {
          date,
          page,
          itemsPerPage,
          search: this.search,
        })
        .then(() => {
          if (this.totalPage && this.totalPage < page) {
            this.options.page = this.totalPage === 0 ? 1 : this.totalPage;
          }
        });
    },

    openAddDialog() {
      this.isEdit = false;
      this.editedIndex = -1;
      this.editedItem = { ...this.defaultItem };
      this.formErrors = {};
      this.dialog = true;
    },

    openEditDialog(item) {
      this.isEdit = true;
      this.editedIndex = this.allData.indexOf(item);
      this.editedItem = {
        id: item.id,
        provider_name: item.provider_name,
        pic_name: item.pic_name,
        pic_job_position: item.pic_job_position,
        pic_phone_number: item.pic_phone_number,
        pic_email: item.pic_email,
        url_callback: item.url_callback,
      };
      this.dialog = true;
    },

    openDeleteDialog(item) {
      this.deleteTarget = { ...item };
      this.dialogDelete = true;
    },

    closeDeleteDialog() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.deleteTarget = null;
      });
    },

    async confirmDelete() {
      if (!this.deleteTarget) return;
      this.deleting = true;
      try {
        const response = await this.$store.dispatch('channelProvider/deleteData', {
          date,
          id: this.deleteTarget.id,
        });

        if (response?.code === 200) {
          showAlert(this.$store, 'Sukses hapus Channel Provider', 'mdi-check-circle', 'green');
          this.closeDeleteDialog();
          this.getData();
        } else {
          const msg = typeof response?.data === 'string'
            ? response.data
            : response?.message_id || response?.message_en || 'Gagal menghapus Channel Provider.';
          showAlert(this.$store, msg, 'mdi-alert', 'red');
        }
      } catch (error) {
        showAlert(this.$store, 'Terjadi kesalahan!', 'mdi-alert', 'red');
      } finally {
        this.deleting = false;
      }
    },

    closeDialog() {
      this.dialog = false;
      this.formErrors = {};
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
        this.isEdit = false;
      });
    },

    async saveProvider(formData) {
      this.formLoading = true;
      this.formErrors = {};

      try {
        let response;
        if (this.isEdit) {
          response = await this.$store.dispatch('channelProvider/updateData', {
            date,
            payload: { ...formData, id: this.editedItem.id },
          });
        } else {
          response = await this.$store.dispatch('channelProvider/createData', {
            date,
            payload: formData,
          });
        }

        if (response?.code === 200) {
          showAlert(
            this.$store,
            this.isEdit ? 'Sukses update Channel Provider' : 'Sukses tambah Channel Provider',
            'mdi-check-circle',
            'green'
          );
          this.closeDialog();
          this.getData();
        } else if (response) {
          this.handleFieldErrors(response);
        }
      } catch (error) {
        showAlert(this.$store, 'Terjadi kesalahan!', 'mdi-alert', 'red');
      } finally {
        this.formLoading = false;
      }
    },

    handleFieldErrors(response) {
      const data = response?.data;

      if (data && typeof data === 'object' && !Array.isArray(data)) {
        this.formErrors = { ...data };
        return;
      }

      if (typeof data === 'string' && data.trim()) {
        showAlert(this.$store, data, 'mdi-alert', 'red');
        return;
      }

      showAlert(
        this.$store,
        response?.message_id || response?.message_en || 'Terjadi kesalahan!',
        'mdi-alert',
        'red'
      );
    },

    merchantCount(item) {
      return Number(item?.status || 0);
    },
  },
};
